<template>
  <div class="page d-flex flex-column align-items-center">
    <div class="container d-flex justify-content-center align-items-start flex-grow-1 pt-5">
      <Otp/>
    </div>

  </div>
</template>

<script>
import Otp from "@/components/Otp.vue";

export default {
  name: "OtpView",
  components: {Otp},
  computed: {
    baseUrl() {
      return process.env.BASE_URL || './';
    }
  }
}
</script>

<style scoped>
.page {
  background: var(--bg-primary);
  transition: var(--transition-speed);
  min-height: 100vh; /* Ensure page takes full viewport height */
}

.banner {
  height: 30vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: var(--text-primary);  /* theme token: replaces hardcoded #fff so banner adapts to light/dark — TicketApp #26670 */
  background: var(--bg-secondary);  /* theme token: replaces hardcoded #40434A with themed secondary surface — TicketApp #26670 */
  margin-top: -2px !important;
  max-height: 280px;
}
</style>
